export const POST_SCHEDULE_BOOKING_REQUEST = 'POST_SCHEDULE_BOOKING_REQUEST'
export const POST_SCHEDULE_BOOKING_SUCCESS = 'POST_SCHEDULE_BOOKING_SUCCESS'
export const POST_SCHEDULE_BOOKING_FAIL    = 'POST_SCHEDULE_BOOKING_FAIL'

export const CHECK_AVAILABILITY_REQUEST = 'CHECK_AVAILABILITY_REQUEST'
export const CHECK_AVAILABILITY_SUCCESS = 'CHECK_AVAILABILITY_SUCCESS'
export const CHECK_AVAILABILITY_FAIL    = 'CHECK_AVAILABILITY_FAIL'

export const FIND_NEAREST_DRIVER_REQUEST = 'FIND_NEAREST_DRIVER_REQUEST'
export const FIND_NEAREST_DRIVER_SUCCESS = 'FIND_NEAREST_DRIVER_SUCCESS'
export const FIND_NEAREST_DRIVER_FAIL    = 'FIND_NEAREST_DRIVER_FAIL'

export const RESET_SCHEDULE_BOOKING_FORM = 'RESET_SCHEDULE_BOOKING_FORM'